import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

import { faBan, faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import {
  Box, Button, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/useGeoCountry'
import useGeoCountries from '@hooks/useGeoCountries'

import ListBlankState from '@components/ListBlankState'
import PageHeader from '@components/PageHeader'

import CountryListItem from '../CountryListItem'

const PageContent = () => {
  // useLocation to refresh the window.location. If not used location won't reload if URL changes
  useLocation()

  const { active } = parsePermittedQueryParams(getQueryParamsFromHash(), ['active'])
  const isActive = active || 'true'

  const geoCountriesPayload = useGeoCountries({
    // @ts-expect-error TS2322
    filters: { active: isActive },
    performHttpRequests: true,
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredGeoCountries,
    filteredGeoCountriesCount,
    hasFilteredGeoCountries,
    loading,
  } = geoCountriesPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      showCreateGeoCountryModal,
    },
  } = pageContext

  const { inactiveGeoCountriesIndexUrl, geoCountriesIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Countries | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button buttonStyle="primaryCreate" onClick={() => showCreateGeoCountryModal()} size="medium">
            Create
          </Button>
        )}
        // @ts-expect-error TS2322
        activeTabBarItemKey={isActive}
        tabBarItems={[
          {
            href: geoCountriesIndexUrl,
            icon: faCheckCircle,
            key: 'true',
            title: 'Active',
          },
          {
            href: inactiveGeoCountriesIndexUrl,
            icon: faBan,
            key: 'false',
            title: 'Inactive',
          },
        ]}
        title="Countries"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredGeoCountries && <ListBlankState />}

            {!loading && hasFilteredGeoCountries && (
              <DashboardModule title="Countries">
                <Box flexDirection="column">
                  <Box flexDirection="column">
                    {filteredGeoCountries.map(geoCountry => (
                      <CountryListItem key={geoCountry.id} geoCountry={geoCountry} />
                    ))}
                  </Box>

                  <DashboardModule.LoadMoreFooter
                    callbacks={{ loadMore }}
                    canLoadMore={canLoadMore}
                    entityCount={filteredGeoCountriesCount}
                    loading={loading}
                  />
                </Box>
              </DashboardModule>
            )}
          </Columns.Main>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
